<section class="content p-3">
  <div class="container card">
    <h3 class="text strat pt-3">Vehicle Model Name</h3>
    <form (ngSubmit)="saveVehicleModel()" [formGroup]="addVehicleModelForm">
      <div class="row pt-3">
        <div class="col-md-4">
          <label for="name">Name</label>
          <input formControlName="name" id="name" type="text" class="form-control default-form-group-border" required
            placeholder="Enter vehicle model name*">
            @if (
              addVehicleModelForm.get('name')?.invalid &&
              addVehicleModelForm.get('name')?.touched
              ) {
              <div>
                <small class="text-danger">Vehicle model name is required</small>
              </div>
            }
          </div>
          <div class="col-md-4">
            <label for="vehicleMake">Vehicle Make</label>
            <select class="form-select" formControlName="vehicleMake" id="vehicleMake" required>
              <option value="">Select Vehicle Make</option>
              @for (option of makeList; track option) {
                <option [value]="option.name">{{option.name}}</option>
              }
            </select>
            @if (
              addVehicleModelForm.get('vehicleMake')?.invalid &&
              addVehicleModelForm.get('vehicleMake')?.touched ) {
              <div>
                <small class="text-danger">Please select vehicle make</small>
              </div>
            }
          </div>
          <div class="col-md-3 py-4">
            <button type="submit" class="btn app-btn-primary" [disabled]="addVehicleModelForm.invalid">Submit</button>
            <div>{{responseMsg}}</div>
          </div>

        </div>
      </form>
    </div>
  </section>